module.exports = "//static.hsappstatic.net/HubspotToolsMenu/static-1.138/css/toolsmenu.css"